import React from "react";
import PropTypes from "prop-types";
import Icon from "../icon";
import { classStringBuilder } from "../../support/helpers";

const propTypes = {
  iconName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

const defaultProps = {
  className: "",
};

const MainOption = ({ iconName, title, className, onClick }) => {
  const defaultClasses = [
    "flex",
    "justify-center",
    "items-center",
    "border-r",
    "md:even:border-r-0",
    "md:border-b",
    "border-t",
    "md:border-t-0",
    "border-light-grey",
    "hover:bg-beige",
    "transition",
    "duration-300",
    "ease-in-out",
    "min-h-110",
    "md:min-h-140",
    "min-w-140",
    "md:min-w-0",
    "main-customisation-option",
  ];

  const additionalClasses = className.split(" ");

  const classes = classStringBuilder(defaultClasses, additionalClasses);

  return (
    <button className={classes} onClick={onClick}>
      <div className="flex flex-col items-center justifiy-between">
        <Icon iconName={iconName} />
        <div className="heading-8 mt-3 md:mt-6">{title}</div>
      </div>
    </button>
  );
};

MainOption.propTypes = propTypes;

MainOption.defaultProps = defaultProps;

export default MainOption;
